import { useRef } from "react";
import TourUploadButton from "./TourUploadButton";
import { isDarkTheme, triggerAnalyticsEvent } from "../../helpers";

export const TourPhotoSuccess = (props) => {
  const { onConfirm, onRetake, children, paragraphText } = props;
  const confirmButtonRef = useRef(null);
  const onConfirmClick = (onConfirm) => () => {
    reportAnalytics();
    onConfirm();
  };

  const reportAnalytics = () => {
    const eventButtonText = confirmButtonRef?.current?.innerText || "Yes";

    triggerAnalyticsEvent("flex_checkout_photo_upload_click", {
      event_action: "photo_confirm_click",
      event_category: "flex_photo_upload",
      event_label: eventButtonText
    });
  };

  const ghostButtonClass = isDarkTheme() ? "btn-ghost-white" : "btn-ghost-orange";

  return (
    <div className="tour-photo__success photo-step">
      <div className="post-checkout-flow__header">
        <h3 className="post-checkout-flow__header-text __staple--small __staple">
          Confirm your photo
        </h3>
      </div>
      <p>{paragraphText}</p>
      {children}
      <p>
        <strong>Should we use this photo?</strong>
      </p>
      <div className="post-checkout-flow__controls">
        <button
          className="btn btn-primary photo"
          onClick={onConfirmClick(onConfirm)}
          ref={confirmButtonRef}>
          Yes
        </button>
        <TourUploadButton
          classList={`btn ${ghostButtonClass}`}
          handleFileChange={onRetake}
          clickEventActionKey="photo_retake_click">
          Retake
        </TourUploadButton>
      </div>
    </div>
  );
};

export default TourPhotoSuccess;
